var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    "+_vm._s(_vm.questions)+"\n  ")]),_c('p',{staticClass:"mt-1 font-semibold"},[_vm._v("Examples")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.examples)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }